import { render, staticRenderFns } from "./webshop-checkout.vue?vue&type=template&id=1676bc68&scoped=true&"
import script from "./webshop-checkout.vue?vue&type=script&lang=js&"
export * from "./webshop-checkout.vue?vue&type=script&lang=js&"
import style0 from "./webshop-checkout.vue?vue&type=style&index=0&id=1676bc68&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1676bc68",
  null
  
)

export default component.exports